import toolsClient from "@/api/toolsClient"
import { toUrlParams } from "@/api/apiUtils"

const create = async (accountKey, campaignData) => {
  const formData = new FormData()

  formData.append("campaign", JSON.stringify(campaignData.campaign))
  formData.append("file", campaignData.file)

  let url = `accounts/${accountKey}/campaigns/`
  if (campaignData.stationKeys && campaignData.stationKeys.length > 0) {
    const searchParams = new URLSearchParams()
    campaignData.stationKeys.forEach((stationKey) => {
      searchParams.append("stationKeys", stationKey)
    })
    url += `?${searchParams.toString()}`
  }

  const { data } = await toolsClient.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return data
}

const get = async (accountKey, id) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/${id}`)
  return data
}

const list = async (accountKey, pageNumber = 0, pageSize = 10, sortBy, sortDesc, search) => {
  let path = `accounts/${accountKey}/campaigns?page=${pageNumber}&size=${pageSize}&sortBy=${sortBy}&sortDirection=${sortDesc}`
  if (search) {
    path += `&advertiser=${search}`
  }
  const { data } = await toolsClient.get(path)
  return data
}

const update = async (accountKey, campaignData) => {
  let url = `accounts/${accountKey}/campaigns`
  if (campaignData.stationKeys && campaignData.stationKeys.length > 0) {
    const searchParams = new URLSearchParams()
    campaignData.stationKeys.forEach((stationKey) => {
      searchParams.append("stationKeys", stationKey)
    })
    url += `?${searchParams.toString()}`
  }
  const { data } = await toolsClient.put(url, campaignData.campaign)
  return data
}

const patch = async (accountKey, patchData) => {
  const { data } = await toolsClient.patch(`accounts/${accountKey}/campaigns`, patchData)
  return data
}

const deleteCampaign = async (accountKey, id) => {
  const { data } = await toolsClient.delete(`accounts/${accountKey}/campaigns/${id}/delete`)
  return data
}

const createRuleChain = async (accountKey, ruleChian) => {
  const { data } = await toolsClient.post(`accounts/${accountKey}/rule-chains/`, ruleChian)
  return data
}

const getRuleChains = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/rule-chains`)
  return data
}

const getTargets = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/targets`)
  return data || []
}

const getTargetDetail = async (accountKey, path, type) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/target/detail?path=${path}&type=${type}`)
  return data
}

const getAdvertisers = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/advertisers`)
  return data || []
}

const getInventory = async (accountKey, offset, from, to, priority, inventoryData) => {
  const url = `accounts/${accountKey}/campaigns/rules/inventory?` + toUrlParams({ offset, from, to, priority })

  const { data } = await toolsClient.post(url, inventoryData || [])

  return data
}

const getReports = async (accountKey, id) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/${id}/reports`)
  return data
}

const getReportFile = async (accountKey, id, types = []) => {
  //try {
  return await toolsClient.get(`accounts/${accountKey}/campaigns/${id}/report/download`, {
    headers: {
      Accept: "application/octet-stream", // Override for binary response
    },
    params: {
      types: types.join(","), // Convert array to comma-separated string, e.g., "DAILY,COUNTRY"
    },
    responseType: "blob", // Expect binary data (Excel file)
  })

  //   // Handle the blob response for file download
  //   const blob = new Blob([response.data], {
  //     type: response.headers['content-type'] || 'application/octet-stream',
  //   });
  //   const url = window.URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //
  //   // Extract filename from Content-Disposition header or use default
  //   const contentDisposition = response.headers['content-disposition'];
  //   let filename = `campaign_report_${id}.xlsx`;
  //   if (contentDisposition) {
  //     const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
  //     if (filenameMatch) {
  //       filename = filenameMatch[1];
  //     }
  //   }
  //   link.download = filename;
  //
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   window.URL.revokeObjectURL(url);
  //
  //   return response.data;
  // } catch (error) {
  //   console.error('Error fetching campaign report:', error);
  //   throw error;
  // }
};


const getAdvertisingDetails = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/audioadvertising/details`)
  return data
}

const getAdvertisingEnabled = async (accountKey) => {
  const { data } = await toolsClient.get(`accounts/${accountKey}/campaigns/audioadvertising/enabled`)
  return data
}

export default {
  create,
  get,
  list,
  update,
  patch,
  deleteCampaign,
  createRuleChain,
  getRuleChains,
  getTargets,
  getTargetDetail,
  getAdvertisers,
  getInventory,
  getReports,
  getReportFile,
  getAdvertisingDetails,
  getAdvertisingEnabled,
}
